import { render, staticRenderFns } from "./CorrectData.vue?vue&type=template&id=7092c472&scoped=true"
import script from "./CorrectData.vue?vue&type=script&lang=js"
export * from "./CorrectData.vue?vue&type=script&lang=js"
import style0 from "./CorrectData.vue?vue&type=style&index=0&id=7092c472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7092c472",
  null
  
)

export default component.exports